
























import Vue from "vue";
import axios from "axios";
import bus from "@/bus";

export default Vue.extend({
  data() {
    return {
      card: {}
    }
  },
  mounted() {
    this.defaultCard()
    bus.$on(":NEW_CARD_ADDED", () => {
      this.defaultCard()
    })
  },
  methods: {
    async defaultCard() {
      try {
        const result = await axios.get('/client/credit-card');
        if (result.data && result.data.notFound) {
          (this.card as any) = null;
        } else {
          this.card = result.data;
        }
      } catch (e) {
        console.log(e)
      }
    },
  }
})
